// extracted by mini-css-extract-plugin
export default {"isDragging":"DraggableContainer_isDragging__S2Y6U"};